/*
 * @Author: ningbo.kang
 * @Date: 2019-11-29 11:34:31
 * @LastEditors: zerui.yao
 * @LastEditTime: 2024-03-29 17:35:21
 * @FilePath: /fed-authority/src/router/frameIn.js
 * @Description: 描述
 */
import layout from '@/layouts/HeaderAsideLayout';
// home页
import basic from './basic';
// 权限管理
import authority from './authority';
import log from './log';

/**
 * 在主框架内显示
 */
export const frameIn = [
  {
    path: '/',
    component: layout,
    redirect: { path: '/authority/my' },
    meta: { title: '我的权限' },
    children: [...basic, ...authority, ...log],
  },
];

export const routeOrigin = [...basic, ...authority, ...log];
